
<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div
              v-if="(role === 7 || role === 8 || role === 3)">
              <div v-if="role === 3">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('distributors.entity_name') }}</label>
                <el-form-item prop="distribuidor">
                  <base-el-select :options="distribuidores" v-model="form['distribuidor.idDistribuidor'].value" class="w-full" clearable filterable
                    value-key="idDistribuidor" :loading="loadingDistribuidores" />
                </el-form-item>
              </div>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.entity_name') }}</label>
              <el-form-item prop="empresa">
                <base-el-select :options="clientes" v-model="form.empresa.value" class="w-full" clearable filterable
                  value-key="idCliente" :loading="loadingClientes" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('uploaderrors.facturaName')}}</label>
              <el-form-item prop="Respuesta">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Respuesta.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('uploaderrors.codError')}}</label>
              <el-form-item prop="codError">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.codError.value"
                  maxlength="100"
                />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('uploaderrors.msgError')}}</label>
              <el-form-item prop="msgError">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.msgError.value"
                  maxlength="100"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'
import { getClients } from '@/services/clients/getClients'
import { getDistributors } from '@/services/distributors/getDistributors'
// import { mapGetters } from 'vuex'

export default {
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      loadingDistribuidores: false,
      loadingClientes: false,
      vuexnamespace: 'uploaderrors',
      distribuidores: [],
      clientes: [],
      form: {
        Respuesta: { label: i18n.t('uploaderrors.facturaName'), value: '' },
        codError: { label: i18n.t('uploaderrors.codError'), value: '' },
        msgError: { label: i18n.t('uploaderrors.msgError'), value: '' },
        empresa: { label: i18n.t('uploaderrors.cliente'), value: '' },
        'distribuidor.idDistribuidor': { label: i18n.t('uploaderrors.distribuidor'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  mounted: async function () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: { idCliente: x.idCliente, Nombre: x.Nombre } }))
      this.loadingClientes = false

      if (this.role === 3) {
        this.loadingDistribuidores = true
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataDistributors))
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: { idDistribuidor: x.IdDistribuidor, Nombre: x.Nombre } }))
        this.loadingDistribuidores = false
      }
    }
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.Respuesta.value = _temp.Respuesta !== undefined && _temp.Respuesta.value !== '' ? _temp.Respuesta.value : ''
        this.form.codError.value = _temp.codError !== undefined && _temp.codError.value !== '' ? _temp.codError.value : ''
        this.form.msgError.value = _temp.msgError !== undefined && _temp.msgError.value !== '' ? _temp.msgError.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form['distribuidor.idDistribuidor'].value = _temp['distribuidor.idDistribuidor'] !== undefined && _temp['distribuidor.idDistribuidor'].value !== '' ? _temp['distribuidor.idDistribuidor'].value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        Respuesta: { label: i18n.t('uploaderrors.facturaName'), value: '' },
        codError: { label: i18n.t('uploaderrors.codError'), value: '' },
        msgError: { label: i18n.t('uploaderrors.msgError'), value: '' },
        empresa: { label: i18n.t('uploaderrors.cliente'), value: '' },
        'distribuidor.idDistribuidor': { label: i18n.t('uploaderrors.distribuidor'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
